import type { LienPlateforme } from '@rh/shared';

const ORIGINE_TUNISIE_TRAVAIL = 'https://www.tunisietravail.net/';

/**
 * « Voir sur Tunisie Travail » : ouvert dans un nouvel onglet du navigateur de
 * l'utilisateur, qui s'y connecte lui-même ; l'application ne contacte jamais la
 * plateforme et ne connaît aucun identifiant. Le lien, reconstruit par l'API sur
 * liste blanche, est contrôlé une seconde fois : rien d'autre qu'une adresse
 * https de tunisietravail.net ne devient un lien.
 */
export function LienVersPlateforme({ lien }: { lien: LienPlateforme }) {
  if (!lien.url.startsWith(ORIGINE_TUNISIE_TRAVAIL)) return null;
  return (
    <a className="bouton-second lien-bouton" href={lien.url} target="_blank" rel="noopener noreferrer">
      Voir sur Tunisie Travail
    </a>
  );
}
